/**
 * DistractionScreen Component
 * Displays distraction phase with puzzle game
 */
import React from 'react';
import PuzzleGame from '../PuzzleGame';
import { getPuzzleSize } from '../../types/test';

interface DistractionScreenProps {
  type: string;
  onComplete: (timeSpent: number, moves: number) => void;
}

export const DistractionScreen: React.FC<DistractionScreenProps> = ({
  type,
  onComplete
}) => {
  const puzzleSize = getPuzzleSize(type);

  return (
    <div className="min-h-screen bg-neutral flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl p-6 max-w-xl w-full">
        <h2 className="text-2xl font-bold text-primary mb-3 text-center">
          Phase de distraction
        </h2>
        <p className="text-gray-600 text-base mb-5 text-center">
          Organisez les couleurs du plus foncé au plus clair
        </p>
        
        <PuzzleGame 
          gridSize={puzzleSize}
          duration={0}
          onComplete={onComplete}
        />
      </div>
    </div>
  );
};

export default DistractionScreen;
